export const maxNumberOfPax = {
  charter: 8,
  dp: 8,
  cruise: 4,
};

export const maxNumberOfRooms = 3;
export const childAgeMax = 17;
